import React from 'react';
import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import { MusicEventBlock } from './MusicEventBlock';
import type { DetailsProps } from './types';

export const DetailsWithImage = ({
    hideStartDate,
    isSeriesParent,
    startDateTime,
    startMonthAbbr,
    startDay,
    hasArtistPresentedByModule,
    hasPresenterOrAgeRestriction,
    eventName,
    eventNameTruncated,
    displayOrganizationName,
    shouldDisplayRsvp,
    displayPrice,
    shouldShowExternalTicketingProvider,
    externalTicketingProviderLabelText,
    orgProfileLink,
    organizationNameTruncated,
    hasPresenter,
    presenter,
    hasAgeRestriction,
    ageRestriction,
    shouldShowPriceOnHero,
}: DetailsProps) => {
    return (
        <div className="l-pad-top-6 l-pad-bot-2 l-lg-pad-bot-4 l-pad-hor-6">
            {!hideStartDate && (
                <Header
                    hasCroppedLogo={true}
                    isSeriesParent={isSeriesParent}
                    startDateTime={startDateTime}
                    startMonthAbbr={startMonthAbbr}
                    startDay={startDay}
                />
            )}
            <Body
                hasCroppedLogo={true}
                isSeriesParent={isSeriesParent}
                startDateTime={startDateTime}
                startMonthAbbr={startMonthAbbr}
                hasArtistPresentedByModule={hasArtistPresentedByModule}
                hasPresenterOrAgeRestriction={hasPresenterOrAgeRestriction}
                eventName={eventName}
                eventNameTruncated={eventNameTruncated}
                displayOrganizationName={displayOrganizationName}
                orgProfileLink={orgProfileLink}
                organizationNameTruncated={organizationNameTruncated}
                hasPresenter={hasPresenter}
                presenter={presenter}
                hasAgeRestriction={hasAgeRestriction}
                ageRestriction={ageRestriction}
            />
            {hasPresenterOrAgeRestriction && (
                <div className="has-user-generated-content listing-hero--image__justify-content">
                    <div className="g-group">
                        <div className="g-cell g-cell-1-1 g-cell--no-gutters">
                            <MusicEventBlock
                                eventNameTruncated={eventNameTruncated}
                                hasPresenter={hasPresenter}
                                presenter={presenter}
                                hasAgeRestriction={hasAgeRestriction}
                                ageRestriction={ageRestriction}
                            />
                        </div>
                    </div>
                </div>
            )}

            {shouldShowPriceOnHero && (
                <Footer
                    hasCroppedLogo={true}
                    displayPrice={displayPrice}
                    shouldDisplayRsvp={shouldDisplayRsvp}
                    shouldShowExternalTicketingProvider={
                        shouldShowExternalTicketingProvider
                    }
                    externalTicketingProviderLabelText={
                        externalTicketingProviderLabelText
                    }
                />
            )}
        </div>
    );
};
